import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { StarSportsLogo } from 'src/assets/logos/StarSportsLogo';
import { StarBrandIcon } from 'src/assets/brandIcons/StarBrandIcon';
import { compliancePopupLogoCss } from 'src/domains/common/universes/compliancePopupLogoCss';

export const StarSportsMainLogoWrapper = withConfig(theme => styled('div', { label: 'StarSportsMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
    padding-bottom: 20px;
    padding-top: 18px;
`);

export const StarSportsMainLogo = styled(StarSportsLogo, { label: 'StarSportsMainLogo' })`
    height: 18px;
    width: 120px;
`;

export const StarBrandIconWrapper = styled(StarBrandIcon, { label: 'StarBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 32px;
    margin: 0 auto;
    width: 32px;
`;

export const CompliancePopupLogo = styled(StarSportsLogo, { label: 'CompliancePopupLogo' })`
    ${compliancePopupLogoCss}
`;
